(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-breeds"]) return;
  try {
    
  var $breedChooser = $('.collection-breeds__breed-chooser')

  $breedChooser.each(function (i, element) {
    var $chooser = $(element)
    var $select = $(element).find('select')

    $select.on('change', function () {
      window.location.href = $(this).val()
    })

    $select.on('chosen:ready', function () {
      $chooser.find('.chosen-single').append("<i class='chevron down'></i>")
    })
    
    $chooser.find('.chosen-container').on('touchstart', function (e) {
      e.stopPropagation()
      e.preventDefault()
      
      $(this).trigger('mousedown')
    })

    $select.each(function (i, element) {
      $(element).chosen()
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  let form = document.querySelector('.footer__newsletter')
  let formUrl = form.getAttribute('data-url')  
  let checkboxInput = document.querySelector('input[type="checkbox"]')
  let checkboxVal = "FALSE";
  const dataPrivacyLabel = document.querySelector('.footer__data-privacy')
  
  const handleCheckboxChange = (event) => {
    let isChecked = event.target.checked;
      
    if (isChecked) {
      checkboxVal = "TRUE"
    }
  };
  
  checkboxInput.addEventListener('change', handleCheckboxChange)
  
  const onSubmit = evt => {
    evt.preventDefault();

    form = document.querySelector('.footer__newsletter')
    formUrl = form.getAttribute('data-url')
    const email = form.querySelector('input[type="email"]').value

    $.ajax({
      url: formUrl,
      type: 'post',
      dataType: 'json',
      data: { email: email, data_privacy: checkboxVal }
    })

    form.classList.add('submitted')
    dataPrivacyLabel.style.display = "none"
  }

  form.addEventListener('submit', onSubmit)

  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', evt => {
      if (evt.detail.sectionId === 'footer') {
        form.addEventListener('submit', onSubmit)
      }
    })

    document.addEventListener('shopify:section:unload', evt => {
      if (evt.detail.sectionId === 'footer') {
        form.removeEventListener('submit', onSubmit)
      }
    })
  }

  } catch(e) { console.error(e); }
})();
})();
